import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import {
  Paragraph,
  View,
  Block,
  DynamicMediaItem,
} from '@uncinc/react-drupal-core';
import {
  Container,
  WysiwygField,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_TABLET,
  SCREEN_NORMAL,
  BLOCK_NEWSLETTER_BLOCK_ID,
} from '../../../config/constants';

import './style.scss';

const NodeLandingPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeLandingPage');
  const node = entity.toJS();
  const heroTitle = node.title[0].value;
  const heroBody = node.body[0]?.processed;
  const media = node.field_media_item[0];

  const { width } = useWindowDimensions();
  const isMobile = width <= SCREEN_TABLET;
  const isTablet = width >= SCREEN_TABLET && width < SCREEN_NORMAL;

  return (
    <>
      <article itemType="http://schema.org/WebPage" className={classes}>
        <Container>
          <div className="NodeLandingPage__hero__image">
            <DynamicMediaItem
              media={media}
              imageAspectRatio={
                isMobile ? '16_9' : (isTablet ? '3_1' : '4_1')
              }
            />
          </div>
        </Container>

        <Container>
          <div className="row">
            <div className="NodeLandingPage__hero__wrapper col-12 col-lg-10 col-xl-8">
              <div className="NodeLandingPage__hero__bar">
                <div className="rectangle" />
                <div className="triangle-right" />
              </div>
              <div className="NodeLandingPage__hero__wrapper__text">
                <h1 className="NodeLandingPage__hero__wrapper__title">{heroTitle}</h1>
                {heroBody && (
                  <WysiwygField
                    property="schema:text"
                    className="NodeLandingPage__hero__wrapper__body"
                    html={heroBody}
                  />
                )}
              </div>
            </div>
          </div>
        </Container>

        {entity.get('field_paragraphs') && (
          <div className="NodeLandingPage__paragraphs">
            {entity.get('field_paragraphs', List()).map((paragraph) => {
              const id = paragraph.get('target_id');
              const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);

              return (
                <Paragraph
                  key={`paragraph:${id}:${language}`}
                  entity={paragraph.get('entity')}
                />
              );
            })}
          </div>
        )}

      </article>

      {/* Newsletter block */}
      <Block
        id={BLOCK_NEWSLETTER_BLOCK_ID}
      />

      {/* Partners slider */}
      <View
        id="partners"
        display="slider"
      />
    </>
  );
};

export default NodeLandingPage;
